import OLViewProperty from 'ol/ViewProperty';

export const ViewProperty = Object.assign({
  MAX_EXTENT: 'maxExtent',
  PROJECTION_TITLE: 'projectionTitle',

  // Used only in classic, can be cleaned up after epic split:
  USES_DEFAULT_SRS: 'usesDefaultSrs'
}, OLViewProperty);
